import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const TESTIMONIALS = [
  {
    quote:
      "This helped me name what I was carrying instead of calling myself lazy.",
    bg: "bg-[#F5E9EC]",
    text: "text-[#380C1E]",
  },
  {
    quote:
      "I finally had language for why I felt stuck and a practical place to begin.",
    bg: "bg-[#4A0E26]",
    text: "text-white",
  },
  {
    quote:
      "It felt like someone sat beside me and helped me find myself again.",
    bg: "bg-[#EFE6D2]",
    text: "text-[#380C1E]",
  },
];

const SLIDER_IMAGES = [
  "https://assets.cdn.filesafe.space/N5B75kjUT85NEZBh2RaZ/media/6a9464fd934a62aec8955f1f.jpg",
  "https://assets.cdn.filesafe.space/N5B75kjUT85NEZBh2RaZ/media/6a94634b934a62aec89538cb.jpg",
  "https://assets.cdn.filesafe.space/N5B75kjUT85NEZBh2RaZ/media/6a946349934a62aec895389b.jpg",
  "https://assets.cdn.filesafe.space/N5B75kjUT85NEZBh2RaZ/media/6a94633c7fb05fdeb8ff1364.jpg",
  "https://assets.cdn.filesafe.space/N5B75kjUT85NEZBh2RaZ/media/6a94649f0914f112151fb9ae.jpg",
  "https://assets.cdn.filesafe.space/N5B75kjUT85NEZBh2RaZ/media/6a946535c71cb92aeff81260.jpg",
  "https://assets.cdn.filesafe.space/N5B75kjUT85NEZBh2RaZ/media/6a94e8790914f112152aafda.jpg",
  "https://assets.cdn.filesafe.space/N5B75kjUT85NEZBh2RaZ/media/6a946489c71cb92aeff804b7.jpg",
  "https://assets.cdn.filesafe.space/N5B75kjUT85NEZBh2RaZ/media/6a9464a90914f112151fba9c.jpg",
  "https://assets.cdn.filesafe.space/N5B75kjUT85NEZBh2RaZ/media/6a95dfde70fc5d91f5b5df16.jpg",
  "https://assets.cdn.filesafe.space/N5B75kjUT85NEZBh2RaZ/media/6a95dfde276f28ee53953c02.jpg",
];

export const WorkbookMiddleSections = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [testimonialSlide, setTestimonialSlide] = useState(0);

  useEffect(() => {
    const isMobile = () => window.innerWidth < 640;
    if (isMobile()) return;
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % SLIDER_IMAGES.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % SLIDER_IMAGES.length);
  };

  const prevSlide = () => {
    setCurrentSlide(
      (prev) => (prev - 1 + SLIDER_IMAGES.length) % SLIDER_IMAGES.length,
    );
  };

  return (
    <>
      {/* SECTION 3: Identity Reset + The Workbook Bundle Banner */}
      <section className="bg-[#9E1B50] text-white py-14 md:py-20 w-full border-y border-[#E8DEC8]">
        <div className="w-full px-4 sm:px-8 lg:px-16 max-w-[1600px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
            <div className="lg:col-span-5 flex justify-center">
              <div className="relative w-full max-w-md aspect-[4/3] flex items-center justify-center">
                <img
                  src="https://assets.cdn.filesafe.space/N5B75kjUT85NEZBh2RaZ/media/6a957aeff22eac14d9b5abff.jpg"
                  alt="Identity Reset workshop and From Burnout to Becoming workbook bundle"
                  className="w-4/5 h-auto object-contain drop-shadow-2xl"
                />
              </div>
            </div>

            <div className="lg:col-span-7 space-y-6">
              <span className="text-xs font-bold uppercase tracking-[0.25em] text-white/80 block">
                SAVE WHEN YOU BUNDLE
              </span>
              <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-normal text-white leading-tight">
                Identity Reset + <br /> The Workbook
              </h2>
              <div className="flex items-baseline gap-4">
                <span className="font-serif text-4xl md:text-5xl font-semibold text-white">
                  $55
                </span>
                <span className="text-xs font-semibold uppercase tracking-wider text-white/70">
                  WORKBOOK + IDENTITY RESET
                </span>
              </div>

              <div className="space-y-3 pt-2 max-w-md">
                <a
                  href="https://store.iamieshiadanielle.com/product-details/product/6a98cd6f86a8dfe2ef9d9ef1/?variant=6a98cd6f86a8dfe2ef9d9ef9"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-white hover:bg-[#FAF6F0] text-[#4A0E26] font-bold uppercase text-[11px] tracking-wider py-4 rounded-xl flex items-center justify-between px-6 transition-all"
                >
                  <span>GET THE BUNDLE</span>
                  <span>→</span>
                </a>
                <Link
                  to="/programs/identity-reset"
                  className="text-xs text-white/80 hover:text-white uppercase tracking-wider font-semibold underline block pt-1"
                >
                  TELL ME MORE ABOUT IDENTITY RESET →
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 4: Identity Reset Standalone */}
      <section className="bg-[#FAF6F0] py-16 md:py-24 w-full">
        <div className="w-full px-4 sm:px-8 lg:px-16 max-w-[1600px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
            <div className="lg:col-span-5">
              <div className="rounded-2xl overflow-hidden bg-neutral-200 border border-[#E8DEC8] aspect-[4/5] relative">
                <img
                  src="https://assets.cdn.filesafe.space/N5B75kjUT85NEZBh2RaZ/media/6a908bca3b02a2a821c17f96.jpg"
                  alt="Identity Reset workshop with Ieshia Danielle"
                  className="w-full h-full object-cover object-center"
                />
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-6 text-white space-y-1">
                  <h3 className="font-serif text-2xl font-bold uppercase tracking-wider">
                    IDENTITY RESET
                  </h3>
                  <p className="text-xs text-white/80 font-light">
                    WORKSHOP + INTERACTIVE EXPERIENCE
                  </p>
                </div>
              </div>
            </div>

            <div className="lg:col-span-7 space-y-6">
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#9E1B50] block">
                A FOCUSED FIRST STEP
              </span>
              <h2 className="font-serif text-4xl md:text-5xl font-normal text-[#380C1E]">
                Identity Reset
              </h2>
              <p className="font-serif text-3xl font-normal text-[#9E1B50]">
                $47
              </p>
              <p className="text-[#380C1E]/80 text-base font-light leading-relaxed">
                Reconnect with who you are beneath the roles, labels, habits,
                and survival patterns that have been making your choices for
                you.
              </p>

              <div className="bg-[#FAF6F0] rounded-2xl border border-[#E8DEC8] p-6 space-y-3">
                <span className="text-[10px] font-bold uppercase tracking-widest text-[#380C1E]/60 block">
                  WHAT'S INSIDE
                </span>
                <ul className="space-y-2 text-xs md:text-sm text-[#380C1E]/80 font-light">
                  <li className="flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#9E1B50]"></span>
                    About one hour of guided video content
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#9E1B50]"></span>
                    30 to 35 minutes of Scripture-rooted teaching from Ieshia
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#9E1B50]"></span>
                    A candid identity conversation with a six-figure
                    entrepreneur
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#9E1B50]"></span>
                    Guided reflection and practical next steps
                  </li>
                </ul>
              </div>

              <a
                href="https://store.iamieshiadanielle.com/product-details/product/6a9990d12ec6f6c3e6a0fe7f"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#9E1B50] hover:bg-[#801440] text-white font-bold uppercase text-[11px] tracking-wider px-8 py-4 rounded-xl inline-flex items-center justify-between w-full max-w-md transition-all"
              >
                <span>ADD TO CART</span>
                <span>→</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 5: Quiz CTA Strip */}
      <section className="bg-[#F5E9EC] py-8 border-y border-[#E8DEC8] w-full">
        <div className="w-full px-4 sm:px-8 lg:px-16 max-w-[1600px] mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <div>
            <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#9E1B50] block">
              NOT SURE WHERE TO BEGIN?
            </span>
            <p className="font-serif text-2xl md:text-3xl font-normal text-[#380C1E]">
              Name the source of your burnout.
            </p>
          </div>
          <a
            href="https://quiz.iamieshiadanielle.com/quiz"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#9E1B50] hover:bg-[#801440] text-white font-bold uppercase text-[11px] tracking-wider px-8 py-3.5 rounded-full transition-all whitespace-nowrap"
          >
            TAKE THE 3-MINUTE QUIZ →
          </a>
        </div>
      </section>

      {/* SECTION 6: Testimonial Quotes */}
      <section className="bg-[#FAF6F0] py-16 md:py-24 w-full">
        <div className="w-full px-4 sm:px-8 lg:px-16 max-w-[1600px] mx-auto space-y-10">
          <div className="text-left space-y-2">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#9E1B50] block">
              WOMEN WHO HAVE BEGUN THE WORK
            </span>
            <h2 className="font-serif text-3xl md:text-5xl font-normal text-[#380C1E]">
              These pages make room for the truth.
            </h2>
          </div>

          {/* Desktop: 3-column grid */}
          <div className="hidden md:grid grid-cols-3 gap-6">
            {TESTIMONIALS.map((t, idx) => (
              <div
                key={idx}
                className={`${t.bg} ${t.text} rounded-3xl p-8 border border-[#E8DEC8] space-y-4 flex items-center justify-center min-h-[200px]`}
              >
                <p className="font-serif text-lg md:text-xl italic text-center leading-snug">
                  "{t.quote}"
                </p>
              </div>
            ))}
          </div>

          {/* Mobile: slider */}
          <div className="md:hidden">
            <div className="overflow-hidden">
              <div
                className="flex transition-transform duration-500 ease-out"
                style={{ transform: `translateX(-${testimonialSlide * 100}%)` }}
              >
                {TESTIMONIALS.map((t, idx) => (
                  <div key={idx} className="w-full flex-shrink-0 px-1">
                    <div
                      className={`${t.bg} ${t.text} rounded-3xl p-8 border border-[#E8DEC8] flex items-center justify-center min-h-[200px]`}
                    >
                      <p className="font-serif text-lg italic text-center leading-snug">
                        "{t.quote}"
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex items-center justify-center gap-2 mt-6">
              {TESTIMONIALS.map((_, idx) => (
                <button
                  key={idx}
                  type="button"
                  onClick={() => setTestimonialSlide(idx)}
                  aria-label={`Go to testimonial ${idx + 1}`}
                  className={`h-2 rounded-full transition-all ${
                    testimonialSlide === idx
                      ? "w-6 bg-[#9E1B50]"
                      : "w-2 bg-[#9E1B50]/30"
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 7: 12-Image Slider */}
      <section className="bg-white py-16 md:py-24 w-full border-y border-[#E8DEC8]">
        <div className="w-full px-4 sm:px-8 lg:px-16 max-w-[1600px] mx-auto space-y-8">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
            <div>
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#9E1B50] block mb-2">
                BECOMING, IN REAL LIFE
              </span>
              <h2 className="font-serif text-3xl md:text-5xl font-normal text-[#380C1E]">
                You do not have to do the work alone.
              </h2>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-xs text-[#380C1E]/60 uppercase font-bold tracking-wider mr-2 hidden sm:inline">
                SWIPE TO EXPLORE →
              </span>
              <button
                onClick={prevSlide}
                type="button"
                className="w-10 h-10 rounded-full border border-[#4A0E26] text-[#4A0E26] flex items-center justify-center hover:bg-[#4A0E26] hover:text-white transition-all"
                aria-label="Previous slide"
              >
                ←
              </button>
              <button
                onClick={nextSlide}
                type="button"
                className="w-10 h-10 rounded-full border border-[#4A0E26] text-[#4A0E26] flex items-center justify-center hover:bg-[#4A0E26] hover:text-white transition-all"
                aria-label="Next slide"
              >
                →
              </button>
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6">
            {[0, 1, 2, 3].map((offset) => {
              const index = (currentSlide + offset) % SLIDER_IMAGES.length;
              const imageUrl = SLIDER_IMAGES[index];
              return (
                <div
                  key={`${index}-${offset}`}
                  className="rounded-3xl overflow-hidden bg-neutral-200 border border-[#E8DEC8] aspect-square shadow-sm transition-all duration-500 group"
                >
                  <img
                    src={imageUrl}
                    alt={`Women working through the From Burnout to Becoming workbook in real life ${index + 1}`}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};
